import axiosInstance from './axiosConfig';

const API_URL = '/api/templates';

const getPublicTemplates = () => {
 return axiosInstance.get(API_URL);
};

const getAdminTemplates = () => {
  return axiosInstance.get(`${API_URL}/admin`);
};

const createTemplate = (templateData) => {
    return axiosInstance.post(`${API_URL}/admin`, templateData);
};

const updateTemplate = (id, templateData) => {
    return axiosInstance.put(`${API_URL}/admin/${id}`, templateData);
};

const deleteTemplate = (id) => {
    return axiosInstance.delete(`${API_URL}/admin/${id}`);
};

const templateService = {
  getPublicTemplates,
  getAdminTemplates,
  createTemplate,
  updateTemplate,
  deleteTemplate,
};

export default templateService;